// BS4 Tooltip - [data-toggle="popover"]
// see: https://stackoverflow.com/questions/13413057/how-to-insert-close-button-in-popover-for-bootstrap

var fn_popover = function () {
  var $close = '<button class="btn close btn-close btn--ghost" aria-label="Fermer cette popin"><span class="ikon-close-disc"></span></button>';
  var $trap = '<button class="btn btn-sm btn--trap" type="button" aria-hidden="true" tabindex="0"></button>'

  // > Hinding on click outside
  $('body').on('click', function (e) {
    $('[data-toggle=popover]').each(function () {
      if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
        (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false
      }
    })
  })

  // > Setting up tooltip for map
  // Creating popup inside maparea and
  // setting focus inside popup area
  // On hidding setting focus back on original link
  //
  $('.js-tooltip-map').popover({
    container: '.map__image',
    trigger: 'click',
    placement: 'auto',
    class: 'tooltip-map',
    html: true,
    title: function () {
      return jQuery(this).data('title')
    }
  })
    .on('shown.bs.popover', function (eventShown) {
      var $popup = $('#' + $(eventShown.target).attr('aria-describedby'));

      $popup.find('.popover-header').attr('tabindex', '-1').focus()
      $popup.find('.popover-header').append($close)

      $popup.append($trap).prepend($trap)

      $popup.find('button.close').click(function (e) {
        $popup.popover('hide')
      })

      //trapping focus
      $popup.find('.btn--trap').on('focus', function(e) {
        $popup.find('.popover-header').focus()
      })

    })
    .on('hide.bs.popover', function (eventHide) {
      var $popup = $('#' + $(eventHide.target).attr('aria-describedby'))

      $popup.find('.btn--trap').remove();

      $popup.parents('.map__image').children().find('a[aria-describedby*="popover"]').focus();

      ;

    })

  $('a.js-tooltip-map').on('click', function (e) { e.preventDefault(); return true; })
}
